import React from 'react';
import { constants, resources } from '../constants';
import i18next from "../i18n";
import { base64toBlob, getBase64 } from './helpers/HelperFunctions';
import { isImageFile } from './helpers/CheckFunctions';
import { History } from './helpers/History';
import { hideModalDialog, showModalDialog } from './ModalDialog';
import { Svg } from './Svg';
import { PdfViewer } from './PdfViewer';
const mime = require('mime-types');
export function unknownErrorMessageDialog(redirectUrl) {
    let closeDialog = () => {
        hideModalDialog("loadingDialog");
        if (redirectUrl) {
            History.push(redirectUrl);
        }
    };
    showModalDialog("loadingDialog", i18next.t("error"), "", <div className="info-message">{i18next.t("unknownErrorMessage")}</div>, "feedPopup", true, [{ title: i18next.t("ok"), clickHandler: closeDialog, class: "btn-primary" }], closeDialog);
}
export function messageDialog(title, message, handleCloseDialog, dialogId = 'modalDialog') {
    let closeDialog = () => {
        hideModalDialog(dialogId);
        if (handleCloseDialog) {
            handleCloseDialog()
        }
    };
    showModalDialog(dialogId, title, "", <div className="info-message">{message}</div>, "feedPopup", true, [{ title: i18next.t("ok"), clickHandler: closeDialog, class: "btn-primary" }], closeDialog);
}
export function yesNoMessageDialog(title, message, handleYes, handleNo, handleCloseDialog) {
    const onYes = () => {
        hideModalDialog('modalDialog');
        if (handleYes) handleYes();
    }
    const onNo = () => {
        hideModalDialog('modalDialog');
        if (handleNo) handleYes();
    }
    const closeDialog = () => {
        hideModalDialog('modalDialog');
        if (handleCloseDialog) handleCloseDialog();
    };
    showModalDialog('modalDialog', title, "", <div className="info-message">{message}</div>, "feedPopup", true, [{ title: i18next.t("yes"), clickHandler: onYes, class: "btn-primary" }, { title: i18next.t("no"), clickHandler: onNo, class: "btn-secondary" }], closeDialog);
}
export function errorMessageDialog(message) {
    messageDialog(i18next.t("error"), message);
}
export function badYoucontrolRequestDialog() {
    errorMessageDialog(i18next.t("badYoucontrolRequestMessage"));
}

export function viewImageDialog(nodeRef) {
    let view = function (path) {
        fetch(path, { method: 'POST' })
            .then(async (response) => {
                if (response.ok) {
                    let data = await response.json()
                    if (data.errorCode) unknownErrorMessageDialog();
                    else {
                        if (data[0].content) {
                            const imageUrl = `data:${data[0].mimeType};base64,` + data[0].content;
                            viewImage(imageUrl, data[0].fileName);
                        }
                        else {
                            showModalDialog("loadingDialog", i18next.t("viewingDocument"), "",
                                <div className="info-message">{i18next.t("viewedDocumentNotFound")}</div>,
                                "feedPopup", true,
                                [{ title: i18next.t("ok"), clickHandler: () => hideModalDialog('loadingDialog'), class: "btn-primary" }]);
                        }
                    }
                }
            });
    }
    view(`file/get?nodeRefs=${nodeRef}&withSign=${false}`);
}
export function viewPdfDialog(nodeRef) {
    let view = function (path) {
        fetch(path, { method: 'POST' })
            .then(async (response) => {
                if (response.ok) {
                    let data = await response.json()
                    if (data.errorCode) unknownErrorMessageDialog();
                    else {
                        let path = `file/get?nodeRefs=${nodeRef}&withSign=${false}`;
                        if (!data[0].content && !response.url.toLowerCase().includes(path.toLowerCase())) view(path);
                        else if (data[0].content) {
                            let objectUrl = window.URL.createObjectURL(base64toBlob(data[0].content, "application/pdf"));
                            viewFile(objectUrl, data[0].fileName);
                        }
                        else {
                            showModalDialog("loadingDialog", i18next.t("viewingDocument"), "",
                                <div className="info-message">{i18next.t("viewedDocumentNotFound")}</div>,
                                "feedPopup", true,
                                [{ title: i18next.t("ok"), clickHandler: () => hideModalDialog('loadingDialog'), class: "btn-primary" }]);
                        }
                    }
                }
            });
    }
    view(`file/get?nodeRefs=${nodeRef}&withSign=${true}`);
}
export async function viewFileFolderSystemFile(urlPath, fileName) {
    const response = await fetch(urlPath, { method: 'POST' });
    if (response.ok) {
        response.blob().then(blobby => {
            const fileType = mime.lookup(fileName);
            const file = new Blob([blobby], { type: fileType });

            if (isImageFile(fileName)) {
                getBase64(file, true).then(base64Info => {
                    const imageUrl = base64Info.content;
                    viewImage(imageUrl);
                });
            }
            else {
                var objectUrl = window.URL.createObjectURL(file);
                viewFile(objectUrl, fileName);
            }
        });
    }
    else
        messageDialog(i18next.t("error"), response.status === 404 ? i18next.t("documentNotFound") : i18next.t("unknownErrorMessage"));
}
function viewFile(objectUrl, fileName) {
    let download = (objectUrl, fileName) => {
        let anchor = document.createElement("a");
        anchor.href = objectUrl;
        anchor.download = fileName;
        anchor.click();
    }
    showModalDialog("loadingDialog", i18next.t("viewingDocument"), "",
        [<div key={0} className="filter-block-header">
            <ul className="filter-header-buttons one-icons">
                <li>
                    <button type="button" className="btn no-bg-btn" onClick={() => download(objectUrl, fileName)}>
                        <div>
                            <Svg src="/img/icn-download.svg" />
                        </div>
                        <span>{i18next.t("download")}</span>
                    </button>
                </li>
            </ul>
        </div>,
        <PdfViewer src={objectUrl} />]
        , "feedPopup max-size with-header-btns", true, [], () => window.URL.revokeObjectURL(objectUrl));
}

export function viewImage(imageUrl) {
    showModalDialog("loadingDialog", "", "", <img src={imageUrl} className="loading-icone" alt="" />, "transparente image-dialog", true);
}
let hideLoaderTimerId = null;
export function showLoader() {
    if (hideLoaderTimerId) {
        clearTimeout(hideLoaderTimerId);
        hideLoaderTimerId = null;
    }
    showModalDialog(constants.placeholderDialogId, "", "", <img src={resources.loadingIcone} className="loading-icone" alt="" />, "transparente", false);
}
export function hideLoader() {
    if (!hideLoaderTimerId)
        hideLoaderTimerId = setTimeout(() => { hideModalDialog(constants.placeholderDialogId); }, 500);
}
export function codeDialog(code) {
    // eslint-disable-next-line default-case
    switch (code) {
        case 413:
            return errorMessageDialog(i18next.t("11"));
    }
}